import React from 'react';

import { logOutUser } from 'src/utils/constants'
import { SCOPES, anyScope } from 'src/utils/permissions'

const Profile = React.lazy(() => import('../views/profile/Profile'));

const Dashboard = React.lazy(() => import('../views/dashboard/Dashboard'));

// Masters
const UserMaster = React.lazy(() => import('../views/userMaster/UserMaster'));
const UserEntry = React.lazy(() => import('../views/userMaster/UserEntry'));
const FindUsers = React.lazy(() => import('../views/userMaster/FindUsers'));

const VendorMaster = React.lazy(() => import('../views/vendorMaster/VendorMaster'));
const VendorEntry = React.lazy(() => import('../views/vendorMaster/VendorEntry'));

const VehicleTypeMaster = React.lazy(() => import('../views/vehicleTypeMaster/VehicleTypeMaster'));
const VehicleTypeEntry = React.lazy(() => import('../views/vehicleTypeMaster/VehicleTypeEntry'));

const VehicleMakeMaster = React.lazy(() => import('../views/vehicleMakeMaster/VehicleMakeMaster'));
const VehicleMakeEntry = React.lazy(() => import('../views/vehicleMakeMaster/VehicleMakeEntry'));

const CustomerMaster = React.lazy(() => import('../views/customerMaster/CustomerMaster'));
const CustomerEntry = React.lazy(() => import('../views/customerMaster/CustomerEntry'));

const ServiceLocation = React.lazy(() => import('../views/serviceLocationMaster/ServiceLocationMaster'));
const ServiceLocationEntry = React.lazy(() => import('../views/serviceLocationMaster/ServiceLocationEntry'));

const BookingMaster = React.lazy(() => import('../views/bookings/BookingMaster'));
const BookingEntry = React.lazy(() => import('../views/bookings/BookingEntry'));
const PreviewBookings = React.lazy(() => import('../views/bookings/PreviewBookings'));
const CustomerBookingMaster = React.lazy(() => import('../views/bookings/customerBookings/CustomerBookingMaster'));
const CustomerAddBooking = React.lazy(() => import('../views/bookings/customerBookings/CustomerAddBooking'));
const VendorBookingMaster = React.lazy(() => import('../views/bookings/vendorBookings/VendorBookingMaster'));
const ViewBooking = React.lazy(() => import('../views/bookings/ViewBooking'));
const ChangeRequests = React.lazy(() => import('../views/bookings/changeRequests/ChangeRequests'));

const ProformaInvoiceMaster = React.lazy(() => import('../views/proformaInvoiceMaster/ProformaInvoiceMaster'));
const ProformaInvoiceEntry = React.lazy(() => import('../views/proformaInvoiceMaster/ProformaInvoiceEntry'));

const VendorInvoiceMaster = React.lazy(() => import('../views/vendorInvoiceMaster/VendorInvoiceMaster'));
const VendorInvoiceGenerate = React.lazy(() => import('../views/vendorInvoiceMaster/VendorInvoiceGenerate'));
const VendorInvoiceEntry = React.lazy(() => import('../views/vendorInvoiceMaster/VendorInvoiceEntry'));

const InvoiceMaster = React.lazy(() => import('../views/invoiceMaster/InvoiceMaster'));
const InvoiceGenerate = React.lazy(() => import('../views/invoiceMaster/InvoiceGenerate'));
const InvoiceEntry = React.lazy(() => import('../views/invoiceMaster/InvoiceEntry'));
const InvoiceCustomerMaster = React.lazy(() => import('../views/invoiceMaster/customerInvoice/InvoiceCustomerMaster'));
const InvoiceViewDetails = React.lazy(() => import('../views/invoiceMaster/customerInvoice/InvoiceViewDetails'));

const PackageMaster = React.lazy(() => import('../views/packageMaster/packageMaster'));
const PackageEntry = React.lazy(() => import('../views/packageMaster/packageEntry'));

const BranchMaster = React.lazy(() => import('../views/branchMaster/BranchMaster'));
const BranchEntry = React.lazy(() => import('../views/branchMaster/BranchEntry'));

const VehicleExpenseMaster = React.lazy(() => import('../views/fuelMaster/FuelMaster'));
const VehicleExpenseEntry = React.lazy(() => import('../views/fuelMaster/FuelEntry'));

// Reports
const TripsReport = React.lazy(() => import('../views/trips/TripsReport'));
const SalesReport = React.lazy(() => import('../views/salesReport/SalesReport'));
const BillCoverReport = React.lazy(() => import('../views/billCoverReport/BillCoverReport'));
const AuditReport = React.lazy(() => import('../views/auditReport/AuditReport'));
const DocumentExpiryReport = React.lazy(() => import('../views/documentExpiryReport/DocumentExpiryReport'));
const MonthlyTurnOverReport = React.lazy(() => import('../views/monthlyTurnOverReport/MonthlyTurnOverReport'));
const ExpiryAgreementReport = React.lazy(() => import('../views/expiryAgreementReport/ExpiryAgreementReport'));
const FleetReport = React.lazy(() => import('../views/fleetReportMaster/FleetReportMaster'));
const VehicleWiseSalesReport = React.lazy(() => import('../views/vehicleWiseSalesReport/VehicleWiseSalesReport'));
const VehicleProductivityReport = React.lazy(() => import('../views/vehicleProductivityReport/VehicleProductivityReport'));
const ServiceDueReport = React.lazy(() => import('../views/serviceDueReport/ServiceDueReport'));
const ProfitLossReport = React.lazy(() => import('../views/profitLossReport/ProfitLossReport'));

// Others
const RoleManagement = React.lazy(() => import('../views/roleManagement/RoleManagement'));

// My Accounts Details
const AccountDetails = React.lazy(() => import('../views/myAccounts/accountDetails/AccountDetails'));

// My Account KYC
const AccountKYC = React.lazy(() => import('../views/myAccounts/accountKYC/AccountKYC'));

// My Account Department
const AccontDepartment = React.lazy(() => import('../views/myAccounts/accountDepartment/AccountDepartment'));
const AccontDepartmentDetails = React.lazy(() => import('../views/myAccounts/accountDepartment/AccountDepartmentDetails'));
const AccountCreateDepartment = React.lazy(() => import('../views/myAccounts/accountDepartment/AccountCreateDepartment'));

// My Account Users
const AccountUsers = React.lazy(() => import('../views/myAccounts/accountUsers/AccountUsers'));
const AccountUserDetails = React.lazy(() => import('../views/myAccounts/accountUsers/AccountUserDetails'));
const AccountCreateUser = React.lazy(() => import('../views/myAccounts/accountUsers/AccountCreateUser'));

// My Account Vehicles
const AccountVehicles = React.lazy(() => import('../views/myAccounts/accountVehicles/AccountVehicles'));
const AccountVehicleDetails = React.lazy(() => import('../views/myAccounts/accountVehicles/AccountVehicleDetails'));
const AccountCreateVehicle = React.lazy(() => import('../views/myAccounts/accountVehicles/AccountCreateVehicle'));

//My Account Drivers
const AccountDrivers = React.lazy(() => import('../views/myAccounts/accountDrivers/AccountDrivers'));
const AccountDriverDetails = React.lazy(() => import('../views/myAccounts/accountDrivers/AccountDriverDetails'));
const AccountCreateDriver = React.lazy(() => import('../views/myAccounts/accountDrivers/AccountCreateDriver'));

//My Account Contact
const AccountContact = React.lazy(() => import('../views/myAccounts/accountContact/AccountContact'));
const AccountContactDetails = React.lazy(() => import('../views/myAccounts/accountContact/AccountContactDetails'));

//My Account Contracts
const AccountContracts = React.lazy(() => import('../views/myAccounts/accountContracts/AccountContracts'));
const AccountContractDetails = React.lazy(() => import('../views/myAccounts/accountContracts/AccountContractDetails'));

//My Account GST
const AccountGST = React.lazy(() => import('../views/myAccounts/accountGST/AccountGST'));

// Credit Notes
const CreditNoteList = React.lazy(() => import('../views/creditNotes/CreditNoteList'));
const CreditNoteGenerate = React.lazy(() => import('../views/creditNotes/CreditNoteGenerate'));
const CreditNoteEntry = React.lazy(() => import('../views/creditNotes/CreditNoteEntry'));

// Debit Notes
const DebitNoteList = React.lazy(() => import('../views/debitNotes/DebitNoteList'));
const DebitNoteGenerate = React.lazy(() => import('../views/debitNotes/DebitNoteGenerate'));
const DebitNoteEntry = React.lazy(() => import('../views/debitNotes/DebitNoteEntry'));

// Settings
// User Preferences
const UserPreferences = React.lazy(() => import('../views/settings/UserPreferences'));

const Logout = () => {
  React.useEffect(() => {
    logOutUser();
  }, []);

  return null;
};

// `scope`: internal users need it (or any of a list) to open the page. Customers, vendors and
// drivers cannot open a scoped page unless it is `shared` with them.
const routes = [
  { path: '/profile', name: 'Profile', element: Profile },

  { path: '/dashboard', name: 'Dashboard', element: Dashboard },

  { path: '/service-location', name: 'Service Location', element: ServiceLocation, scope: anyScope(SCOPES.SERVICE_LOCATION) },
  { path: '/service-location/entry', name: 'Entry', element: ServiceLocationEntry, scope: SCOPES.SERVICE_LOCATION.CREATE },
  { path: '/service-location/entry/:id', name: 'Entry', element: ServiceLocationEntry, scope: anyScope(SCOPES.SERVICE_LOCATION) },

  { path: '/vehicle-type', name: 'Vehicle Type', element: VehicleTypeMaster, scope: anyScope(SCOPES.VEHICLE_TYPE) },
  { path: '/vehicle-type/entry', name: 'Entry', element: VehicleTypeEntry, scope: SCOPES.VEHICLE_TYPE.CREATE },
  { path: '/vehicle-type/entry/:id', name: 'Entry', element: VehicleTypeEntry, scope: anyScope(SCOPES.VEHICLE_TYPE) },

  { path: '/vehicle-make', name: 'Vehicle Make', element: VehicleMakeMaster, scope: anyScope(SCOPES.VEHICLE_MAKE) },
  { path: '/vehicle-make/entry', name: 'Entry', element: VehicleMakeEntry, scope: SCOPES.VEHICLE_MAKE.CREATE },
  { path: '/vehicle-make/entry/:id', name: 'Entry', element: VehicleMakeEntry, scope: anyScope(SCOPES.VEHICLE_MAKE) },

  { path: '/vehicle-expense', name: 'Vehicle Expense', element: VehicleExpenseMaster, scope: SCOPES.VEHICLE_EXPENSE.LIST },
  { path: '/vehicle-expense/entry', name: 'Entry', element: VehicleExpenseEntry, scope: SCOPES.VEHICLE_EXPENSE.CREATE },
  { path: '/vehicle-expense/entry/:id', name: 'Entry', element: VehicleExpenseEntry, scope: [SCOPES.VEHICLE_EXPENSE.READ, SCOPES.VEHICLE_EXPENSE.UPDATE] },

  { path: '/vendors', name: 'Vendors', element: VendorMaster, scope: SCOPES.VENDOR.LIST },
  { path: '/vendors/entry', name: 'Entry', element: VendorEntry, scope: SCOPES.VENDOR.CREATE },
  { path: '/vendors/entry/:id', name: 'Entry', element: VendorEntry, scope: [SCOPES.VENDOR.READ, SCOPES.VENDOR.UPDATE] },

  { path: '/customers', name: 'Customers', element: CustomerMaster, scope: SCOPES.CUSTOMER.LIST },
  { path: '/customers/entry', name: 'Entry', element: CustomerEntry, scope: SCOPES.CUSTOMER.CREATE },
  { path: '/customers/entry/:id', name: 'Entry', element: CustomerEntry, scope: [SCOPES.CUSTOMER.READ, SCOPES.CUSTOMER.UPDATE] },

  { path: '/bookings', name: 'Bookings', element: BookingMaster, scope: SCOPES.BOOKING.LIST },
  { path: '/bookings/entry', name: 'Entry', element: BookingEntry, scope: SCOPES.BOOKING.CREATE },
  { path: '/bookings/entry/:id', name: 'Entry', element: BookingEntry, scope: [SCOPES.BOOKING.READ, SCOPES.BOOKING.UPDATE] },
  { path: '/bookings/preview', name: 'Entry', element: PreviewBookings, scope: SCOPES.BOOKING.CREATE },
  { path: '/bookings/change-requests', name: 'Change Requests', element: ChangeRequests, scope: SCOPES.BOOKING.CHANGE_REQUEST_VIEW },
  { path: '/customer-bookings', name: 'Bookings', element: CustomerBookingMaster },
  { path: '/customer-bookings/details/:id', name: 'Details', element: ViewBooking },
  { path: '/customer-bookings/entry', name: 'Entry', element: CustomerAddBooking },
  { path: '/vendor-bookings', name: 'Bookings', element: VendorBookingMaster },
  { path: '/vendor-bookings/details/:id', name: 'Details', element: ViewBooking },

  { path: '/proforma-invoices', name: 'Proforma Invoice', element: ProformaInvoiceMaster, scope: SCOPES.PROFORMA_INVOICE.LIST },
  { path: '/proforma-invoices/entry', name: 'Entry', element: ProformaInvoiceEntry, scope: SCOPES.PROFORMA_INVOICE.CREATE },
  { path: '/proforma-invoices/entry/:id', name: 'Entry', element: ProformaInvoiceEntry, scope: [SCOPES.PROFORMA_INVOICE.READ, SCOPES.PROFORMA_INVOICE.UPDATE] },

  { path: '/vendor/invoices', name: 'Vendor Invoice', element: VendorInvoiceMaster, scope: SCOPES.VENDOR_INVOICE.LIST },
  { path: '/vendor/invoices/generate', name: 'Vendor Invoice', element: VendorInvoiceGenerate, scope: SCOPES.VENDOR_INVOICE.CREATE },
  { path: '/vendor/invoices/entry', name: 'Entry', element: VendorInvoiceEntry, scope: SCOPES.VENDOR_INVOICE.CREATE },
  { path: '/vendor/invoices/entry/:id', name: 'Entry', element: VendorInvoiceEntry, scope: [SCOPES.VENDOR_INVOICE.READ, SCOPES.VENDOR_INVOICE.UPDATE] },

  { path: '/invoices', name: 'Invoice', element: InvoiceMaster, scope: SCOPES.INVOICE.LIST },
  { path: '/invoices/generate', name: 'Invoice', element: InvoiceGenerate, scope: SCOPES.INVOICE.CREATE },
  { path: '/invoices/entry', name: 'Entry', element: InvoiceEntry, scope: SCOPES.INVOICE.CREATE },
  { path: '/invoices/entry/:id', name: 'Entry', element: InvoiceEntry, scope: [SCOPES.INVOICE.READ, SCOPES.INVOICE.UPDATE] },
  { path: '/invoices/customer', name: 'Invoice', element: InvoiceCustomerMaster },
  { path: '/invoices/view-details/:id', name: 'Details', element: InvoiceViewDetails },

  { path: '/branch', name: 'Branch', element: BranchMaster, scope: anyScope(SCOPES.BRANCH) },
  { path: '/branch/entry', name: 'Entry', element: BranchEntry, scope: SCOPES.BRANCH.CREATE },
  { path: '/branch/entry/:id', name: 'Entry', element: BranchEntry, scope: anyScope(SCOPES.BRANCH) },

  { path: '/credit-note', name: 'Credit Notes', element: CreditNoteList, scope: SCOPES.CREDIT_NOTE.LIST },
  { path: '/credit-note/generate', name: 'Credit Notes', element: CreditNoteGenerate, scope: SCOPES.CREDIT_NOTE.CREATE },
  { path: '/credit-note/entry', name: 'Entry', element: CreditNoteEntry, scope: SCOPES.CREDIT_NOTE.CREATE },
  { path: '/credit-note/entry/:id', name: 'Details', element: CreditNoteEntry, scope: [SCOPES.CREDIT_NOTE.READ, SCOPES.CREDIT_NOTE.UPDATE] },

  { path: '/debit-note', name: 'Debit Notes', element: DebitNoteList, scope: SCOPES.DEBIT_NOTE.LIST },
  { path: '/debit-note/generate', name: 'Debit Notes', element: DebitNoteGenerate, scope: SCOPES.DEBIT_NOTE.CREATE },
  { path: '/debit-note/entry', name: 'Entry', element: DebitNoteEntry, scope: SCOPES.DEBIT_NOTE.CREATE },
  { path: '/debit-note/entry/:id', name: 'Entry', element: DebitNoteEntry, scope: [SCOPES.DEBIT_NOTE.READ, SCOPES.DEBIT_NOTE.UPDATE] },

  { path: '/package', name: 'Package', element: PackageMaster, scope: anyScope(SCOPES.PACKAGE) },
  { path: '/package/entry', name: 'Package', element: PackageEntry, scope: SCOPES.PACKAGE.CREATE },
  { path: '/package/entry/:id', name: 'Package', element: PackageEntry, scope: anyScope(SCOPES.PACKAGE) },

  { path: '/report/trips', name: 'Trips', element: TripsReport, scope: SCOPES.TRIP.LIST, shared: true },
  { path: '/report/sales', name: 'Sales Report', element: SalesReport, scope: SCOPES.REPORT.CUSTOMER_SALES },
  { path: '/report/bill-cover', name: 'Bill Cover Report', element: BillCoverReport, scope: SCOPES.REPORT.BILL_COVER },
  { path: '/report/audit', name: 'Audit Report', element: AuditReport, scope: SCOPES.REPORT.BOOKING_AUDIT },
  { path: '/report/profit-loss', name: 'Profit/Loss Reports', element: ProfitLossReport, scope: SCOPES.REPORT.PROFIT_LOSS },
  { path: '/report/doc-expiry', name: 'Document Expiry Report', element: DocumentExpiryReport, scope: SCOPES.REPORT.DOCUMENT_EXPIRY },
  { path: '/report/monthy-turnover', name: 'Monthly Turn Over Report', element: MonthlyTurnOverReport, scope: SCOPES.REPORT.MONTHLY_TURNOVER },
  { path: '/report/agreement-expiry', name: 'Expiry Agreement Reports', element: ExpiryAgreementReport, scope: SCOPES.REPORT.AGREEMENT_EXPIRY },
  { path: '/report/fleet', name: 'Fleet Reports', element: FleetReport, scope: SCOPES.REPORT.FLEET },
  { path: '/report/vehicle-wise-sales', name: 'Vehicle Wise Sales Reports', element: VehicleWiseSalesReport, scope: SCOPES.REPORT.VEHICLE_SALES },
  { path: '/report/vehicle-productivity', name: 'Vehicle Productivity Reports', element: VehicleProductivityReport, scope: SCOPES.REPORT.VEHICLE_PRODUCTIVITY },
  { path: '/report/service-due', name: 'Service Due Report', element: ServiceDueReport, scope: SCOPES.REPORT.SERVICE_DUE },

  { path: '/find-users', name: 'Find Users', element: FindUsers, scope: SCOPES.USER.LIST },

  { path: '/users', name: 'Users', element: UserMaster, scope: SCOPES.USER.LIST },
  { path: '/users/entry', name: 'Entry', element: UserEntry, scope: SCOPES.USER.CREATE },
  { path: '/users/entry/:id', name: 'Entry', element: UserEntry, scope: [SCOPES.USER.READ, SCOPES.USER.UPDATE] },

  { path: '/roles', name: 'Role Management', element: RoleManagement, scope: SCOPES.ROLE.LIST },

  { path: '/account/details', name: 'Details', element: AccountDetails },

  { path: '/account/kyc', name: 'KYC', element: AccountKYC },

  { path: '/account/department', name: 'Department', element: AccontDepartment },
  { path: '/account/department/details', name: 'Details', element: AccontDepartmentDetails },
  { path: '/account/department/entry', name: 'Entry', element: AccountCreateDepartment },

  { path: '/account/users', name: 'Users', element: AccountUsers },
  { path: '/account/users/details', name: 'Details', element: AccountUserDetails },
  { path: '/account/users/entry', name: 'Entry', element: AccountCreateUser },

  { path: '/account/vehicles', name: 'Vehicles', element: AccountVehicles },
  { path: '/account/vehicles/details', name: 'Details', element: AccountVehicleDetails },
  { path: '/account/vehicles/entry', name: 'Entry', element: AccountCreateVehicle },

  { path: '/account/drivers', name: 'Drivers', element: AccountDrivers },
  { path: '/account/drivers/details', name: 'Details', element: AccountDriverDetails },
  { path: '/account/drivers/entry', name: 'Entry', element: AccountCreateDriver },

  { path: '/account/contact', name: 'Contact', element: AccountContact },
  { path: '/account/contact/details', name: 'Details', element: AccountContactDetails },

  { path: '/account/contracts', name: 'Contracts', element: AccountContracts },
  { path: '/account/contracts/details', name: 'Details', element: AccountContractDetails },

  { path: '/account/gst', name: 'GST', element: AccountGST },

  { path: '/settings/preferences', name: "User Preferences", element: UserPreferences, scope: SCOPES.SETUP.SETTINGS },

  { path: '/account/logout', name: 'Logout', element: Logout },
]

export default routes
